import { Button, Grid, Typography } from "@mui/material"
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


const EarlyPayment = ({ onClick }: { onClick: Function }) => {
    return (
        <Grid container flexDirection={"column"} gap={"1.5rem"} sx={{ padding: "20px", border: "1px solid var(--border-color)", minHeight: "130px", background: "var(--input-bg-color)", borderRadius: "5px" }}>
            <Grid item sx={{ height: "70%" }}>
                <Grid container>
                    <Grid item xs={1}>
                        <img src="/images/flower.png" alt="flower in the hand" />
                    </Grid>
                    <Grid item xs={11}>
                        <Typography sx={{ color: "var(--primary-text-color)", fontWeight: "bold", fontSize: "0.875rem" }}>
                            دوست عزیز
                        </Typography>
                        <Typography sx={{ color: "var(--primary-text-color)", fontWeight: "bold", fontSize: "0.875rem" }}>
                            بابت پرداخت به موقع اقساط از شما متشکریم!
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item sx={{ height: "30%" }}>
                <Button onClick={() => onClick()} sx={{ background: "#F99600", color: "#fff", '&:hover': { background: "#F99600" } }} fullWidth>
                    <AutoAwesomeIcon sx={{ fontSize: "24px", marginLeft: "5px" }} />
                    <span style={{ fontWeight: "bold" }}>
                        پرداخت زودتر از موعد
                    </span>
                </Button>
            </Grid>
        </Grid>
    )
}

export default EarlyPayment